import React from 'react'
import { useRouter } from 'next/router'
import Image from 'next/image'

import styled from '@emotion/styled'
import { useTranslation } from 'next-i18next'

import { FullWidthButton } from 'components/common/FullWidthButton'
import Bookmark from 'components/common/Bookmark'

const KTCFooter = ({
  id,
  status,
  live_event,
  onCount,
  message,
  mode,
  cartHandler,
}) => {
  const router = useRouter()
  const { t } = useTranslation()

  return (
    <Container>
      <div className="interested">
        <Image
          src="/ktc/heart-fill.png"
          alt=""
          width={24}
          height={24}
          style={{ marginTop: 2 }}
        />
        {live_event && live_event.toLocaleString('ko-kr')} {t('ktc:interested')}
      </div>
      <SpaceBetwewen>
        <div>
          <Bookmark store_id={id} isKTC={true} onCount={onCount} />
        </div>
        <RedButton
          onClick={
            mode === 'store'
              ? () => router.push(`/food/${id}/product`)
              : mode === 'product'
              ? cartHandler
              : null
          }
          disabled={!status}
          style={{
            backgroundColor: status ? '#333' : '#ddd',
            cursor: status ? 'pointer' : 'inherit',
          }}
        >
          {message}
        </RedButton>
      </SpaceBetwewen>
    </Container>
  )
}

export default KTCFooter

const Container = styled.footer`
  max-width: 480px;
  width: 100%;
  background-color: white;
  padding: 11px 16px;
  position: fixed;
  bottom: 0;
  background-color: white;
  z-index: 1;
  padding-top: 16px;
  border-top: 1px solid #eee;

  .interested {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
  }
`

const SpaceBetwewen = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  div {
    width: 50px;
    height: 50px;
    border-radius: 5px;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  img {
    position: static !important;
    cursor: pointer;
  }
`

const RedButton = styled(FullWidthButton)`
  width: calc(100% - 120px);
  height: 50px;
  margin: 0;
`
